import axios from "axios";
import { ResponsibilityType } from "containers/Admin/CreateOrEditEvent/CreateOrEditEvent";
import { EventResponsibility } from "interfaces/events";
import { Member } from "interfaces/users";

export function debounce(func: () => void, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | undefined;

  return function executedFunction() {
    timeout && clearTimeout(timeout);

    timeout = setTimeout(() => {
      timeout = undefined;
      func();
    }, wait);
  };
}

export function getWeek(date: Date): number {
  const d = new Date(date);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  return weekNo;
}

export async function getMainResponsible(eventId: number): Promise<Member | null> {
  const response = await axios.get<EventResponsibility[]>(`/events/${eventId}/event-responsibility/`);
  const mainResponsibleId = response?.data?.filter(
    r => r.responsibility_type === ResponsibilityType.MAIN_RESPONSIBLE
  )[0]?.bl_member;
  if (!mainResponsibleId) return null;
  const memberResponse = await axios.get<Member>(`/internal/members/${mainResponsibleId}/`);
  return memberResponse.data;
}

/** This is used to get a base 64 URL that can be used to preview the file */
export const getBase64 = (img: File) => {
  const reader = new FileReader();
  reader.readAsDataURL(img);
  return new Promise<string | null>((resolve, reject) => {
    reader.addEventListener("load", () => resolve(reader.result as string | null));
    reader.addEventListener("error", error => reject(error));
  });
};
